import { Flex, Box, Text } from '@chakra-ui/react';
import { useMediaQuery } from '@chakra-ui/media-query';
import ChakraMarkdown from '../components/ChakraMarkdown';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import { useQuery } from '@apollo/client';
import { GET_PRIVACY_POLICY } from '../apollo/queries/GetPrivacyPolicy';

const PrivacyPolicy = ({ global }) => {
  const [isLargerThan1024] = useMediaQuery('(min-width: 1024px)');

  const { data, loading, error } = useQuery(GET_PRIVACY_POLICY, {
    context: { clientName: 'strapi' },
    fetchPolicy: 'cache-first',
  });


  return (
    <Layout global={global}>
      <Seo seo={{}} />
      <Flex maxW={720} margin={isLargerThan1024 ? '4rem auto' : '4rem 2rem'}>
        {!loading && (
          <Box>
            <Text
              style={{
                fontSize: '1.2rem',
                fontWeight: 600,
                lineHeight: '1.7',
                textAlign: 'left',
              }}
              my={10}
            >
              Updated {data.policy.data.attributes.privacyPolicy.version}
            </Text>
            <ChakraMarkdown
              content={data.policy.data.attributes.privacyPolicy.content}
              onLinkClick={() => null}
            />
          </Box>
        )}
      </Flex>
    </Layout>
  );
};


export default PrivacyPolicy;
